
module.exports = function isEmail (string) {
    return (/.+\@.+\..+/).test(string);
};


//////////////////
// WEBPACK FOOTER
// ../~/segmentio-facade/~/is-email/index.js
// module id = 377
// module chunks = 0